import { Traversal } from 'arktype';

import { isProbablyValidIBAN } from '@/utility/iban';

export const stringRequiredAndMaxLength =
  (maxLength: number) =>
  (value: string, ctx: Traversal): boolean => {
    if (value.length < 1) {
      return ctx.reject({ message: 'VALIDATION_REQUIRED' });
    }

    if (value.length > maxLength) {
      return ctx.reject({ message: `VALIDATION_TOO_LONG_${maxLength}` });
    }

    return true;
  };

export const stringMaxLength =
  (maxLength: number) =>
  (value: string, ctx: Traversal): boolean => {
    if (value.length > maxLength) {
      return ctx.reject({ message: `VALIDATION_TOO_LONG_${maxLength}` });
    }

    return true;
  };

export const validIbanOrAccountNumber = (value: string, ctx: Traversal): boolean => {
  if (value.length < 4) {
    return ctx.reject({ message: 'IBAN_VALIDATION_TOO_SHORT_4' });
  }

  if (isProbablyValidIBAN(value)) {
    // Validate full IBAN format: 2 letters + 2 numbers + up to 30 alphanumeric characters
    const ibanFullPattern = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;

    return ibanFullPattern.test(value)
      ? true
      : ctx.reject({ message: 'IBAN_VALIDATION_INVALID_FORMAT' });
  }

  // Check if it's an account number (only contains digits)
  if (!/^[A-Z0-9]+$/.test(value)) {
    return ctx.reject({ message: 'IBAN_VALIDATION_INVALID_ACCOUNT_NUMBER' });
  }

  return true;
};

export const validEmail = (value: string, ctx: Traversal): boolean => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!emailPattern.test(value)) {
    return ctx.reject({ message: 'EMAIL_INVALID_FORMAT' });
  }

  return true;
};
